'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

var _StepButton = require('./StepButton');

var _StepButton2 = _interopRequireDefault(_StepButton);

var _vueScrollto = require('vue-scrollto');

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _cart = require('../../components/cart');

var _cart2 = _interopRequireDefault(_cart);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "Step2",
  components: {
    StepButton: _StepButton2.default
  },
  computed: Object.assign({}, (0, _vuex.mapState)({
    activeLenses: function activeLenses(state) {
      return state.prescription.activeLenses;
    },
    activePrescription: function activePrescription(state) {
      return state.prescription.activePrescription;
    },
    finalLens: function finalLens(state) {
      return state.prescription.finalLens;
    },
    finalVariant: function finalVariant(state) {
      return state.prescription.finalVariant;
    },
    frame: function frame(state) {
      return state.prescription.frame;
    },
    options: function options(state) {
      return state.prescription.options;
    },
    buttons: function buttons(state) {
      return state.prescription.meta.options;
    },
    totalPrice: function totalPrice(state) {
      return state.prescription.totalPrice;
    },
    cancelButton: function cancelButton(state) {
      return state.prescription.cms.global.cancel_button;
    },
    cms: function cms(state) {
      return state.prescription.cms.step2;
    },
    addToCartButton: function addToCartButton(state) {
      return state.prescription.cms.global.add_to_cart;
    }
  }), {
    continueButtonContent: function continueButtonContent() {
      var content = Object.keys(this.finalVariant).length > 0 ? this.addToCartButton : this.cms.buttons.apply_lens_type;
      return content;
    },
    selectActiveLenses: function selectActiveLenses() {
      var lenses = this.activeLenses.filter(function (lens) {
        var titleTest = lens.title.split(':')[1].trim().toLowerCase();
        return titleTest === 'classic' ? false : true;
      });
      return lenses;
    },
    selectClassicLens: function selectClassicLens() {
      var lenses = this.activeLenses.filter(function (lens) {
        var titleTest = lens.title.split(':')[1].trim().toLowerCase();
        return titleTest === 'classic' ? true : false;
      });
      return lenses;
    },
    classicLensVariant: function classicLensVariant() {
      var lenses = this.activeLenses.filter(function (lens) {
        var titleTest = lens.title.split(':')[1].trim().toLowerCase();
        return titleTest === 'classic' ? true : false;
      });
      return lenses[0].variants[0];
    }
  }),
  data: function data() {
    var _JSON$parse = JSON.parse(document.getElementById('ShopifyData').innerHTML),
        customer = _JSON$parse.customer;

    return {
      nextDisabled: true,
      customer: customer,
      lensProps: { '_item_type': 'specs_lens' }
    };
  },

  methods: Object.assign({}, (0, _vuex.mapMutations)(['setFinalLens', 'setStep', 'setFrameOptions', 'setFinalVariant']), {
    selectLens: function selectLens(lens) {
      var options = this.options;

      options.step2.name = 'Lens Type: ' + lens.title.split(':')[1];
      options.step2.cost = 'free';

      // Clear any visual options if user has backtracked
      options.step3.cost = 0;

      this.nextDisabled = false;
      this.setFinalLens(lens);
      this.setFrameOptions(options);
      this.setFinalVariant({});
    },
    selectLensAndSetVariant: function selectLensAndSetVariant(lens) {
      var options = this.options;

      options.step2.name = 'Lens Type: ' + lens.title.split(':')[1];
      options.step2.cost = 'free';

      // Clear any visual options if user has backtracked
      options.step3.cost = 0;

      this.nextDisabled = false;
      this.setFrameOptions(options);
      this.setFinalLens(lens);
      this.setFinalVariant(this.classicLensVariant);
    },
    activeLens: function activeLens(id) {
      return this.finalLens.id === id;
    },
    inactiveLens: function inactiveLens(id) {
      return this.finalLens.id && this.finalLens.id !== id;
    },
    selectOptions: function selectOptions() {
      var _this = this;

      var element = document.querySelector('.PrescriptionHeader');
      var options = { container: '.PrescriptionLensData' };

      _vueScrollto2.default.scrollTo(element, 300, options);
      setTimeout(function () {
        if (Object.keys(_this.finalVariant).length > 0) {
          _this.addToCart();
        } else {
          _this.setStep(3);
        }
      }, 300);
    },
    returnContent: function returnContent(name) {
      var buttons = this.buttons;

      var button = buttons.filter(function (button) {
        return button.name.toLowerCase().trim() === name.toLowerCase().trim();
      });
      return button.length > 0 ? button[0].content : '';
    },
    returnImage: function returnImage(name) {
      var buttons = this.buttons;

      var button = buttons.filter(function (button) {
        return button.name.toLowerCase().trim() === name.toLowerCase().trim();
      });

      if (button.length > 0) {
        var noImage = button[0].icon.includes('no-image');
        if (noImage) {
          return '';
        } else {
          return button[0].icon;
        }
      } else {
        return '';
      }
    },
    addToCart: function addToCart() {
      var _this2 = this;

      var self = this;
      var customer = this.customer;

      var element = document.querySelector('.PrescriptionHeader');
      var options = { container: '.PrescriptionLensData' };

      var data = {
        frameId: this.frame.selectedVariant.id,
        lensId: this.finalVariant.id,
        lensProps: this.lensProps,
        frameProps: {
          '_item_type': 'specs_frame',
          'vision': this.activePrescription.type,
          'lens type': this.finalLens.title,
          '_lens_variant_id': this.finalVariant.id,
          '_lens_price': this.finalVariant.price
        },
        customer: customer
      };
      data.lensProps['_vision'] = this.activePrescription.type;
      data.lensProps['_frame'] = this.frame.title;
      if (this.activePrescription.id) {
        data.frameProps['_prescription_id'] = this.activePrescription.id;
        data.lensProps['_prescription_id'] = this.activePrescription.id;
      }

      var cartInstance = new _cart2.default(data);

      _vueScrollto2.default.scrollTo(element, 300, options);
      setTimeout(function () {
        if (_this2.activePrescription.id) {
          cartInstance.addLens();
          self.$emit('add-to-cart');
        } else {
          cartInstance.postPrescription(_this2.activePrescription, _this2.finalLens);
          self.$emit('add-to-cart');
        }
      }, 300);
    }
  })
};